import PropTypes from 'prop-types';
import styled from 'styled-components';
import { format } from 'date-fns';
import locales from '../utils/locales';

const MatchDateWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  font-weight: bold;
  justify-content: space-between;
`;
const DayName = styled.div`
  color: var(--color-grey-500);
  font-family: var(--font-family-thomas-headline);
  font-size: 14px;
  line-height: 16px;
  align-self: start;
  margin-top: var(--space-100);

  /* Desktop only */
  @media (min-width: 768px) {
    color: ${(props) => (props.active ? '#fff' : 'var(--color-grey-500)')};
  }
`;
const DayOfMonth = styled.span`
  display: block;
  font-size: 38px;
  line-height: 38px;
  margin: 0 var(--space-100);
`;

const MonthYearWrapper = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 16px;
`;

const Month = styled.span`
  display: block;
`;
const Year = styled.span`
  color: var(--color-grey-500);
  font-family: var(--font-family-thomas-headline);
  /* Desktop only */
  @media (min-width: 768px) {
    color: ${(props) => (props.active ? 'var(--color-grey-100)' : 'var(--color-grey-500)')};
  }
`;

const MatchDate = ({ fixture, active, siteId }) => {
  const matchDate = new Date(fixture.matchDate);
  const dayName = format(matchDate, locales[siteId].dayShort, {
    locale: locales[siteId].lang,
  }).toUpperCase();
  const date = format(matchDate, 'd', { locale: locales[siteId].lang });
  const month = format(matchDate, 'MMM', {
    locale: locales[siteId].lang,
  }).toUpperCase();
  const year = format(matchDate, 'yyyy', { locale: locales[siteId].lang });

  return (
    <MatchDateWrapper>
      <DayName active={active}>{dayName.toUpperCase()}</DayName>
      <DayOfMonth>{date}</DayOfMonth>
      <MonthYearWrapper>
        <Month>{month}</Month>
        <Year active={active}>{year}</Year>
      </MonthYearWrapper>
    </MatchDateWrapper>
  );
};

MatchDate.propTypes = {
  fixture: PropTypes.shape({
    matchDate: PropTypes.string,
  }).isRequired,
  active: PropTypes.bool,
  siteId: PropTypes.number.isRequired,
};

MatchDate.defaultProps = {
  active: false,
};

export default MatchDate;
